/** スポット名の最大文字数 */
export const MAX_SPOT_NAME_LENGTH = 100;

/** スポット説明文の最大文字数 */
export const MAX_SPOT_DESCRIPTION_LENGTH = 500;

/** スポット住所の最大文字数 */
export const MAX_SPOT_ADDRESS_LENGTH = 200;

/** コメントの最大文字数 */
export const MAX_COMMENT_LENGTH = 256;

/** ユーザーbioの最大文字数 */
export const MAX_USER_BIO_LENGTH = 500;

/** ニックネームの最大文字数 */
export const MAX_NICKNAME_LENGTH = 50;

/** 通報本文の最大文字数（理由が'other'の場合） */
export const MAX_REPORT_BODY_LENGTH = 300;

/** スポットタグの最大数 */
export const MAX_SPOT_TAGS = 10;

/** タグの最大文字数 */
export const MAX_TAG_LENGTH = 20;

/** 1回のアップロードで投稿できる写真の最大枚数 */
export const MAX_PHOTOS_PER_UPLOAD = 3;

/** スポットあたりの写真の最大枚数（超過時は古いものから論理削除） */
export const MAX_PHOTOS_PER_SPOT = 10;

/** チェックイン可能な最大距離（メートル） */
export const MAX_CHECKIN_DISTANCE_METERS = 100;

/** 近隣スポット検索のデフォルト半径（メートル） */
export const DEFAULT_SEARCH_RADIUS_METERS = 1000;

/** 自動非表示になる通報数 */
export const AUTO_HIDE_REPORT_COUNT = 5;

/** スポット詳細の直近チェックイン表示件数 */
export const RECENT_CHECKINS_LIMIT = 10;

/** スポット詳細の近隣スポット表示件数 */
export const NEARBY_SPOTS_LIMIT = 5;

/** スポット詳細の近隣スポット検索半径（メートル） */
export const NEARBY_SPOTS_RADIUS_METERS = 1000;

/** 画像の最大幅（ピクセル） */
export const IMAGE_MAX_WIDTH = 1200;

/** 画像の最大高さ（ピクセル） */
export const IMAGE_MAX_HEIGHT = 1200;

/** 画像品質（WebP変換時） */
export const IMAGE_QUALITY = 80;

/** 愛車名の最大文字数 */
export const MAX_BIKE_MODEL_LENGTH = 100;

/** 愛車説明の最大文字数 */
export const MAX_BIKE_DESCRIPTION_LENGTH = 500;

/** ギア紹介・走行スタイル各フィールドの最大文字数 */
export const MAX_GEAR_FIELD_LENGTH = 100;

/** 走行スタイルの最大文字数 */
export const MAX_RIDING_STYLE_LENGTH = 100;

/** アバター画像のサイズ（正方形） */
export const AVATAR_SIZE = 400;
